var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "empty" },
    [
      _c("svg-icon", {
        staticClass: "empty-icon",
        attrs: { name: "empty", original: "" }
      }),
      _c("span", { staticClass: "empty-text" }, [_vm._v("暂无应用")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }